module.exports = {"id":"235042","name":"Dimitri Liénard","rating":"75","photo":"./data/images/photos/0/235042.png","club":{"name":"RC Strasbourg","logo":"./data/images/clubs/RCStrasbourg.png"},"positions":["MC","MOC","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DimitriLienard0.json
// module id = 1103
// module chunks = 0